/**
 * 却下ボタン（取り消せない操作なので2段階: 「却下」→「本当に却下する」— DESIGN-SYSTEM.md の danger の規則）
 */

import { useEffect, useRef, useState } from 'react'

export function RejectButton({ label = '却下', disabled, onConfirm, className = '' }: {
  label?: string
  disabled?: boolean
  onConfirm: () => void
  className?: string
}) {
  const [confirming, setConfirming] = useState(false)
  // 「やめる」で確認を閉じたら、再表示される「却下」へフォーカスを戻す（キーボード操作が途切れない）
  const [returnFocus, setReturnFocus] = useState(false)
  const first = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    if (!confirming && returnFocus) { first.current?.focus(); setReturnFocus(false) }
  }, [confirming, returnFocus])

  if (!confirming) {
    return (
      <button ref={first} disabled={disabled} onClick={() => setConfirming(true)} className={`gm-btn gm-btn-ghost ${className}`}>
        {label}
      </button>
    )
  }
  return (
    <span role="group" aria-label="却下の確認" className={`inline-flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-xs text-ink-muted">却下すると元に戻せません。</span>
      {/* 1段目のボタンが消えてもキーボード操作が途切れないよう、確認ボタンへフォーカスを移す */}
      <button autoFocus disabled={disabled} onClick={() => { setConfirming(false); onConfirm() }} className="gm-btn gm-btn-danger">
        本当に却下する
      </button>
      <button onClick={() => { setConfirming(false); setReturnFocus(true) }} className="gm-btn gm-btn-ghost">やめる</button>
    </span>
  )
}
